export default "<img src=\"../../assets/spinner-gif.gif\" alt=\"carregando...\">"